import LegalShell from '@/components/LegalShell';

export default function TermsPage() {
  return (
    <LegalShell eyebrow="Legal" title="Terms &amp; Conditions." lastUpdated="April 2026">
      <div data-testid="terms-page" className="space-y-6 text-foreground/85 leading-relaxed">
        <p>
          These Terms govern your use of <strong>Radiance Hub</strong> (the “Service”), operated by the
          Radiance Hub Team from Mumbai, Maharashtra, India. By creating an account or using the Service,
          you agree to these Terms.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">1. Eligibility</h2>
        <p>You must be at least 18 years old, or the age of majority in your jurisdiction, to use the Service.</p>

        <h2 className="font-display text-2xl text-ink mt-8">2. Account &amp; security</h2>
        <p>
          You are responsible for keeping your login credentials confidential and for all activity under
          your account. Notify us at <a className="underline underline-offset-4" href="mailto:Webuser@radiancehub.org">Webuser@radiancehub.org</a>
          {' '}if you suspect unauthorized access.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">3. Credits &amp; AI features</h2>
        <p>
          Certain features (AI Q&amp;A, Photo Styling, Regimen Generation) require credits. 1 credit = US $1 or
          INR ₹80. Credits are consumed per use, as disclosed on each feature. New users receive 3 free
          welcome credits. Credits have no monetary cash value and cannot be transferred between accounts.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">4. No medical advice</h2>
        <p>
          Content, AI responses and product information are for educational and informational purposes
          only. They are not a substitute for advice from a licensed dermatologist, physician or other
          qualified professional. Always consult a healthcare professional before acting on any content
          you see on the Service.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">5. Acceptable use</h2>
        <p>You agree not to:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Use the Service for any unlawful purpose;</li>
          <li>Upload images that violate another person’s rights or depict minors;</li>
          <li>Attempt to reverse-engineer, scrape or overload the Service;</li>
          <li>Resell or redistribute credits or AI outputs without written consent.</li>
        </ul>

        <h2 className="font-display text-2xl text-ink mt-8">6. Intellectual property</h2>
        <p>
          All brand elements, copy, design and code belong to Radiance Hub or its licensors. Product
          information and images are attributed to the respective brands. You retain ownership of any
          content you upload, but grant us a limited license to process it solely to provide the Service.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">7. Payments &amp; refunds</h2>
        <p>
          Payments are processed by Razorpay. By purchasing credits, you agree to Razorpay’s terms.
          Credits purchased through the Service are <strong>non-refundable</strong>. See our{' '}
          <a href="/refund" className="underline underline-offset-4">Refund Policy</a> for details.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">8. Termination</h2>
        <p>
          We may suspend or terminate accounts that violate these Terms. You may delete your account at
          any time by contacting support. Unused credits are forfeited upon account closure.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">9. Disclaimer &amp; liability</h2>
        <p>
          The Service is provided “as is” without warranties of any kind. To the maximum extent permitted
          by law, Radiance Hub is not liable for indirect, incidental, special or consequential damages
          arising from your use of the Service. Our total liability will not exceed the amount you paid
          to us in the 3 months preceding the claim.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">10. Governing law</h2>
        <p>
          These Terms are governed by the laws of India. Any disputes will be subject to the exclusive
          jurisdiction of the courts of Mumbai, Maharashtra.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">11. Changes to these Terms</h2>
        <p>
          We may update these Terms from time to time. We will notify users of material changes via
          email or in-app notice. Continued use of the Service after changes constitutes acceptance.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">12. Contact</h2>
        <p>
          Radiance Hub, Mumbai, Maharashtra, India. For questions, write to{' '}
          <a className="underline underline-offset-4" href="mailto:Webuser@radiancehub.org">Webuser@radiancehub.org</a>.
        </p>
      </div>
    </LegalShell>
  );
}
